/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Grid } from '@mui/material';
import React from 'react'
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import ContentCard from '../../../../../components/ui-elements/cards/ContentCard';
import { FaBuilding } from 'react-icons/fa';
import { MdPermDeviceInformation } from 'react-icons/md';
import { BsPersonBadgeFill, BsServer } from 'react-icons/bs';

const ManageOrgsPage = () => {


    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Organizations'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-organizations-details" title="Organizations Details" subTitle="Manage Organizations Details" icon={<FaBuilding />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-organizations-applications" title="Applications" subTitle="Manage Organizations Applications" icon={<MdPermDeviceInformation />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-organizations-users" title="Users" subTitle="Manage Organizations Users" icon={<BsPersonBadgeFill />}></ContentCard>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <ContentCard link="/manage-organizations-identity-providers" title="Identity Providers" subTitle="Manage Organizations Identity Providers" icon={<BsServer />}></ContentCard>
                    </Grid>
                </Grid>
            </Box>

        </>
    )

}

export default ManageOrgsPage;
